import { StoreContext } from "@roc/feature-app-core";
import { useContext } from "react";
import { SendgridEmailSettingsStore } from "../stores/sendgridEmailSettingsStore";

export const useSendgridEmailSettingsStore = () => useContext<{
  sendgridEmailSettingsStore: SendgridEmailSettingsStore;
}>(StoreContext);